import { render, staticRenderFns } from "./cwts_more.vue?vue&type=template&id=7aafb2ca&"
import script from "./cwts_more.vue?vue&type=script&lang=js&"
export * from "./cwts_more.vue?vue&type=script&lang=js&"
import style0 from "./cwts_more.vue?vue&type=style&index=0&id=7aafb2ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports